import api from "./api";

export const postTemplateOSOne = async (body: any) => {
    const response = await api.post(`templateOS/`, body);
    return response.data;
};

export const getTemplateOSAll = async (type?: string) => {
    const response = await api.get(`templateOS/listAll${type ? `/?type=${type}` : ''}`);
    return response.data;
};

export const putTemplateOSAll = async (id: string, body: any) => {
    const response = await api.put(`templateOS/${id}`, body);
    return response.data;
};

export const deleteTemplateOSAll = async (id: string) => {
    const response = await api.delete(`templateOS/${id}`);
    return response.data;
};